import { FC } from 'react';

import { IconProps } from '../types';

const WithNaturalFlavorsIcon: FC<IconProps> = ({ size, ...props }) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    {...props}
    aria-hidden="true"
  >
    <path
      d="M14.2819 35.9998C16.4451 36.0201 17.0578 34.6312 19.9933 34.6158C22.9288 34.6312 23.5415 36.0177 25.7047 35.9974C28.1388 35.9759 29.9992 33.6144 31.3937 31.5139C35.2907 25.6428 35.6977 18.7536 33.2943 15.0915C31.5864 12.4879 28.891 10.9656 26.3576 10.9656C23.7781 10.9656 22.1565 12.3651 20.0229 12.3651C17.8893 12.3651 16.2085 10.968 13.629 10.968C11.0956 10.968 8.40016 12.4903 6.69228 15.0939C4.28897 18.7561 4.69584 25.6452 8.59293 31.5164C9.98738 33.6168 11.8478 35.9784 14.2819 35.9998Z"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.2385 28.9069C10.5405 25.1708 10.2588 20.7868 11.9226 18.4563"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.6826 3V5.27586C25.6826 6.48306 24.9633 7.6408 23.6828 8.49442C22.4024 9.34803 20.6658 9.82759 18.855 9.82759V7.55172C18.855 6.34453 19.5743 5.18678 20.8548 4.33317C22.1352 3.47955 23.8718 3 25.6826 3Z"
      fill="#030303"
    />
  </svg>
);

export default WithNaturalFlavorsIcon;
